<template>
  <div>
    <main>
      <section>
        <div class="container">
          <div class="row">
            <mobileUserNav></mobileUserNav>

            <userInfo></userInfo>

            <div class="col_xl_8 col_l_8 col_m_8 col_s_12">
              <p class="user_title">Subscription</p>

              <div class="preload" v-if="subscriptionLoading">
                <img
                    src="@/assets/img/preloader_icon.svg"
                    alt=""
                    class="preloader"
                />
              </div>

              <template v-else>
                <div
                    v-if="subscription.status !== 'deleted'"
                    class="curent_plan_settings"
                >
                  <p class="uptitle">Current plan</p>

                  <h1 class="plan_title">{{ subscription.planName }}</h1>

                  <div>
                    <div
                        v-if="
                        subscription.status === 'active' ||
                        subscription.status === 'trialing'
                      "
                    >

                      <p class="plan_info">
                        <template v-if="subscription.status === 'trialing'">
                            <span
                            >Your trial ends in
                              {{ trialDays(subscription.nextPaymentDate) }}
                              days</span
                            >
                          <br/>
                          <br/>
                        </template>

                        <template v-if="subscription.nextPaymentDate">
                          Next payment of ${{ subscription.amount }} ({{
                            subscription.interval
                          }}) occurs on
                          {{ timeStamp(subscription.nextPaymentDate) }}
                        </template>
                      </p>

                      <div class="btns_wrap">
                        <router-link
                            to="/user_plan"
                            v-if="subscription.status === 'active'"
                            class="color_btn hover_op"
                        >Change plan
                        </router-link>

                        <button
                            v-if="subscription.planId !== 'free'"
                            class="colored_btn hover_op"
                            @click="show_drop = !show_drop"
                        >
                          Manage
                        </button>

                        <div class="drop" :class="{ active: show_drop }">
                          <button
                              v-if="subscription.status === 'active'"
                              class="hover_op"
                              @click="pauseSubscription"
                          >
                            Pause subscription
                          </button>

                          <button
                              class="hover_op"
                              @click="cancelSubscription"
                          >
                            Cancel subscription
                          </button>
                        </div>
                      </div>

                    </div>

                    <div v-else-if="subscription.status === 'paused'">
                      <p class="plan_info">
                        Your subscription has been paused on
                        {{ timeStamp(subscription.pausedOn) }}
                      </p>
                      <div>
                        <button
                            @click="resumeSubscription"
                            class="color_btn hover_op"
                        >
                          Resume subscription
                        </button>
                      </div>
                    </div>

                    <div v-else-if="subscription.status === 'past_due'">
                      <p class="plan_info">
                        Your subscription is past due because we were unable to
                        process your payment method. We will try again on
                        {{ formatReceiptDate(subscription.nextRetryDate) }}
                      </p>
                    </div>
                  </div>
                </div>

                <div v-if="subscription.status !== 'deleted' && subscription.paymentMethod">
                  <div class="items_counter">
                    Payment method
                  </div>

                  <div v-if="subscription.paymentMethod && subscription.paymentMethod === 'card'">
                    <div class="item">
                      {{ subscription.cardType }} **** **** ****
                      {{ subscription.lastFourDigits }}

                      <button class="hover_op" @click="updatePaymentMethod">
                        Edit
                      </button>
                    </div>
                  </div>

                  <div class="item" v-else>
                    <img src="@/assets/img/pay_pal_logo.png" alt=""/>

                    <button class="hover_op" @click="updatePaymentMethod">
                      Edit
                    </button>
                  </div>
                </div>

                <div
                    class="curent_plan_settings"
                    v-if="subscription && subscription.status === 'deleted'"
                >
                  <div v-if="isAfterToday(subscription.cancelAt)">
                    <p class="plan_info">
                      Your subscription has been canceled and will remain valid
                      until {{ timeStamp(subscription.cancelAt) }}
                    </p>
                    <div class="btns_wrap">
                      <button
                          @click="resumeCanceledSubscription"
                          class="color_btn hover_op"
                          style="width: 220px"
                      >
                        Resume subscription
                      </button>
                    </div>
                  </div>

                  <div v-else class="plan_info">
                    <p class="uptitle">Current plan</p>

                    <h1 class="plan_title">Free</h1>

                    <p class="uptitle">No credit card required</p>

                    <div class="btns_wrap">
                      <router-link to="/user_plan" class="color_btn hover_op"
                      >Change plan
                      </router-link>
                    </div>
                  </div>
                </div>

                <div class="items_counter" v-if="receipts.length">Receipts</div>

                <div
                    class="item"
                    v-for="receipt in receipts"
                    v-bind:key="receipt._id"
                >
                  <span>{{ formatReceiptDate(receipt.createdAt) }}</span>

                  <div class="size_dnld hover_op">
                    <a
                        :href="receipt.receiptUrl"
                        rel="nofollow"
                        target="_blank"
                        class="hover_op download"
                    ></a>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </section>
    </main>

    <footerComponent></footerComponent>
  </div>
</template>

<script>
import footerComponent from "@/components/footerComponent.vue";
import inputWrap from "@/components/inputWrap.vue";
import userInfo from "@/components/userInfo.vue";
import axios from "axios";
import mobileUserNav from "@/components/mobileUserNav.vue";
import moment from "moment";

export default {
  name: "UserSubscriptions",

  components: {
    inputWrap,
    userInfo,
    footerComponent,
    mobileUserNav,
  },

  mounted() {
    if (this.$route.query.change_success) {
      this.$store.dispatch("onSuccess", "Your plan was updated successfully");
      // removing ?change_success=true from the URL
      this.$router.replace({query: null});
    }
  },

  data() {
    return {
      monthly: false,
      billing_plans: null,
      show_drop: false,
    };
  },

  computed: {
    receipts() {
      return this.$store.state.billing.receipts;
    },

    subscriptionLoading() {
      return this.$store.state.billing.isLoading;
    },

    subscription() {
      return this.$store.state.billing.subscription;
    },
  },

  methods: {
    trialDays(nextPayment) {
      return moment(nextPayment).diff(moment.now(), "days");
    },

    hide() {
      this.show_drop = false;
    },

    timeStamp(data) {
      return this.$moment(data).format("lll");
    },

    formatReceiptDate(date) {
      return moment(date).format("DD/MM/YYYY");
    },

    isAfterToday(date) {
      return moment(date).isAfter(moment.now());
    },

    async updatePaymentMethod() {
      await this.$store.dispatch("updatePaymentMethod");
      this.$store.dispatch("onSuccess", "Payment method updated successfully");
    },

    async resumeSubscription() {
      try {
        await this.$store.dispatch("resumeSubscription");
        this.$store.dispatch(
            "onSuccess",
            "Your subscription was resumed successfully."
        );
      } catch (e) {
        this.$store.dispatch("onError", e);
        console.error(e);
      }
    },

    resumeCanceledSubscription() {
      this.$store.dispatch("resumeCanceledSubscription", "previous").catch((error) => {
        this.$store.dispatch("onError", error);
        console.error(error);
      });
    },

    async pauseSubscription() {
      try {
        await this.$store.dispatch("pauseSubscription");
        this.$store.dispatch(
            "onSuccess",
            "Your subscription was paused successfully"
        );
      } catch (e) {
        this.$store.dispatch("onError", e);
        console.error(e);
      } finally {
        this.hide();
      }
    },

    async cancelSubscription() {
      try {
        await this.$store.dispatch("cancelSubscription");
        this.$store.dispatch(
            "onSuccess",
            "Your subscription was canceled successfully"
        );
        this.hide();
      } catch (e) {
        this.$store.dispatch("onError", e);
        console.error(e);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.curent_plan_settings {
  margin-top: 96px;
  margin-bottom: 64px;
  border-radius: 16px;
  border: 1px solid #000;
  padding: 64px 32px;
  text-align: center;

  @media all and (max-width: 767px) {
    padding: 32px 16px;
    margin-bottom: 32px;
    margin-top: 64px;
  }

  .uptitle {
    opacity: 0.64;
    color: #000;
    font-family: "Nunito Sans", sans-serif;
    font-size: 16px;
    font-weight: 400;
    line-height: 16px;
    margin-bottom: 24px;
  }

  .plan_title {
    margin-bottom: 16px;
    color: #000;
    font-family: "Playfair Display", serif;
    font-size: 36px;
    font-weight: 400;
    line-height: 48px;

    @media all and (max-width: 767px) {
      line-height: 32px;
      font-size: 24px;
    }
  }

  .plan_info {
    opacity: 0.64;
    color: #000;
    font-family: "Nunito Sans", sans-serif;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    margin-bottom: 64px;

    @media all and (max-width: 767px) {
      margin-bottom: 32px;
    }
  }
}

.btns_wrap {
  display: flex;
  align-items: center;
  justify-content: center;

  @media all and (max-width: 767px) {
    flex-wrap: wrap;
  }

  // This link is the only element in the div when the user has no plan, and needs top-margin in this case
  a:only-child {
    margin-top: 48px;
  }

  & > button,
  & > a {
    font-size: 16px;
    width: 152px;

    @media all and (max-width: 767px) {
      width: 100% !important;
      flex: 1 1 100%;
    }

    & + button {
      margin-left: 16px;

      @media all and (max-width: 767px) {
        margin-left: 0;
        margin-top: 16px;
      }
    }
  }

  .drop {
    width: 422px;
    left: 51%;
    top: 100%;

    @media all and (max-width: 767px) {
      width: calc(100% + 32px);
      left: -16px;
    }
  }
}

.items_counter {
  margin-top: 64px;
  margin-bottom: 32px;
  color: #000;
  font-family: "Nunito Sans", sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;

  @media all and (max-width: 767px) {
    margin-top: 32px;
    margin-bottom: 16px;
  }
}

.item {
  height: 64px;
  border-radius: 16px;
  background-color: #fff;
  justify-content: space-between;
  display: flex;
  align-items: center;
  color: #000;
  font-family: "Nunito Sans", sans-serif;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  text-transform: uppercase;
  padding-left: 20px;
  padding-right: 20px;

  & + .item {
    margin-top: 16px;
  }
}

.size_dnld {
  color: #000;
  font-family: "Nunito Sans", sans-serif;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  text-transform: none;
}

.download {
  display: block;
  width: 24px;
  height: 24px;
  margin-left: 16px;
  background: url("../assets/img/download_icon.svg") no-repeat center / contain;
}

.preload {
  text-align: center;
  margin-bottom: 128px;
}

.terms_title {
  margin-top: 96px;
}
</style>
